  import { defineStore } from 'pinia'
import {useAgencyStore} from '@/stores/agency'


import { availResteValidationData } from './utl.js'
import axios from '@/plugins/axios'

export default defineStore('hotelsKudenix', {
  state: () => ({
    hotel: {
      _id: '',
      active: false,
      checkIn: '',
      checkOut: '',
      lowestPrice: 0,
      highestPrice: 0,
      services: [],
      images: [],
      certified: false,
      release: 0,
      name: '',
      description: {},
      place: '',
      placeAddress: '',
      comments: '',
      city: '',
      cityName: '',
      category: '',
      bookingCode: '',
      agency: '',
      createdAt: '',
      updatedAt: '',
      offers: []
    },
    reserve: {
      hotel: {},
      start: '',
      end: '',
      companions: [],
      room: {},
      holder: {},
      price: 0,
      currency: '',
      countryCode: '',
      observations: '',
      comments: '',
      country: '',
      destination: {},
      rooms: [],
      payments: {},
      paymentsDetails: [],
      cancellationPolicies: [],
      bookingCodes: [],
    },
    errors: [],
    paxes:[{
      cant: 1, 
      numberOfPeople: 2,
      children: 0,
      childrenAge: [],
      adults: 2,
      adultsAge: [30, 30]
    }],
    optionRadioQty: {},
    payments: {},
    changedAges: {},
    isAgeChange: false,
    hotels: [],
    option_selected: [],
    rangePrice: [0, 0],
    cancelPolicies: [],
    isQuery: false,
    modal: false,
    police_dialog: false,
    country: '',
    countryCode: '',
    provider_id: '',
    itemsFound: 0,
    expires: 0,
    start: '',
    end: '',
    comments: '',
    keyword: '',
    destination: {},
    numberOfAdults: 2,
    numberOfChildren: '',
    totalNumberOfPeople: 2,
    nights: 2,
    version: '2.0.0'
  }),
  actions: {
    async avail(cbk) {
     
      let url = `api/hotel/kudenix/avail`
      let response = null
      this.isQuery = false
      this.errors = []
      const agencyStore = useAgencyStore()
      const test = agencyStore?.mode === 'production' ? false : true

      const start = this.start
      const end = this.end
      const paxes = this.paxes.map((pax)=>{
        return {
          adults: pax.adultsAge,
          children: pax.childrenAge,
        }
      })
      const country = this.country
      const countryCode = this.countryCode
      const keyword = this.keyword
      const destination = this.destination
      const numberOfAdults = this.numberOfAdults
      const numberOfChildren = this.numberOfChildren
      const totalNumberOfPeople = this.totalNumberOfPeople
      const provider_id = this.provider_id
      const nights = this.nights

      const errors = availResteValidationData({
        start,
        end,
        paxes,
        countryCode,
        country,
        keyword,
        destination,
        numberOfAdults,
        numberOfChildren,
        totalNumberOfPeople,
        provider_id
      })

      if (errors.errors) {
        this.errors = errors.data
        return
      }

      const data = {
        countryCode: countryCode,
        destination: destination?._id,
        start,
        end,
        provider: provider_id,
        paxes: paxes,
        simulate: test,
        numberOfAdults,
        numberOfChildren,
        nights,
      }

      this.preload = true
      this.hotels = []

      response = await axios.post(`${url}`, data)

      const { success = false, response: hotelResponse = {} } = { ...response?.data }

      const {
        lowestPrice = 0,
        highestPrice = 0,
        itemsFound = 0,
        expires = 0,
        items = []
      } = { ...hotelResponse }

      if (success) {
        this.hotels = items
        this.lowestPrice = lowestPrice
        this.highestPrice = highestPrice
        this.expires = expires
        this.itemsFound = expires
        this.rangePrice = [lowestPrice, highestPrice]
        this.isQuery = true
        this.preload = true
      }
      if( typeof cbk === 'function') cbk(items)
    },
    async booking({ isEstimate = false }) {
      let test = false

      const url = `api/voucher`

      // if(rootState.agency.mode === 'sandbox')
      test = false

      const data = {
        hotelCode: `${this.hotel?._id}`,
        provider: this.provider_id,
        bookingInfo: this.reserve?.hotel,
        start: this.start,
        end: this.end,
        destination: this.destination,
        client: {
          name: `${this.reserve.holder?.name} ${this.reserve.holder?.surname}`,
          email: `${this.reserve.holder?.email}`,
          address: `${this.reserve.holder?.address}`,
          document: this.reserve?.holder?.document,
          documentType: this.reserve?.holder?.documentType,
          age: this.reserve?.holder?.age,
          country: this.country,
          city: this.reserve?.holder?.city,
          postalCode: this.reserve?.holder?.postalCode,
          nationality: this.country,
          phones: [this.reserve?.holder?.phone]
        },
        price: this.reserve.price,
        currency: this.reserve.price.currency,
        payments: this.reserve.payments,
        paymentsDetails: this.reserve.paymentsDetails,
        cancellationPolicies: this.reserve.cancellationPolicies,
        country: this.country,
        rooms: this.reserve.rooms,
        bookingCodes: this.reserve?.bookingCodes,
        companions: this.reserve.companions,
        comments: this.reserve?.comments || '',
        observations: this.reserve.observations,
        type: 'hotels-kudenix',
        integrator: 'kudenix',
        status: 'confirmed',
        test: this.test,
        isEstimate
      }

      return await axios.post(`${url}`, data)
    },
    async startReservation(payload) {
      const {
        price = 0,
        companions = [],
        payments = {},
        cancellationPolicies = [],
        rooms = [],
        hotel = {},
        bookingCodes = [],
        paymentsDetails = [],
        currency = ''
      } = payload

      const start = this.start || ''
      const end = this.end || ''
      const countryCode = this.countryCode || ''
      const comments = this.hotel?.comments || ''
      const country = this.country || ''
      const destination = this.destination || {}

      const reserve = {
        hotel,
        start,
        end,
        companions,
        rooms,
        payments,
        countryCode,
        comments,
        price,
        country,
        destination,
        cancellationPolicies,
        bookingCodes,
        paymentsDetails,
        currency
        }

      this.saveReserve(reserve)

      return {
        error: false,
        message: ''
      }
    },

    saveReserve(payload) {
      const {
        hotel = {},
        rooms = [],
        start = '',
        end = '',
        currency = '',
        companions = [],
        payments = {},
        holder = {
          name: ``,
          email: '',
          address: ``,
          document: '',
          documentType: '',
          age: '',
          country: '',
          city: '',
          postalCode: '',
          nationality: '',
          phones: []
        },
        price = 0,
        countryCode = '',
        bookingCodes= [],
        paymentsDetails= [],
        country = '',
        destination = '',
        comments = '',
        cancellationPolicies = ''
      } = payload

      this.reserve.hotel = hotel
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.price = price
      this.reserve.companions = companions
      this.reserve.payments = payments
      this.reserve.paymentsDetails = paymentsDetails
      this.reserve.countryCode = countryCode
      this.reserve.country = country
      this.reserve.destination = destination
      this.reserve.holder = holder
      this.reserve.bookingCodes = bookingCodes
      this.reserve.comments = comments
      this.reserve.cancellationPolicies = cancellationPolicies
      this.reserve.rooms = rooms
      this.reserve.currency = currency
    }
  },
  persist: true
})
